// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jG-uq","top":"styles_top__3QW1K","left":"styles_left__3eJ2T","description":"styles_description__1NYTb"};